import axios from 'axios';

const endpoint = import.meta.env.VITE_ENDPOINT || 'http://localhost:4000';
const returnOpsEndpoint = import.meta.env.VITE_RETURN_BACKEND || 'http://localhost:4001';
const ocpKey = import.meta.env.VITE_OCP_APIM_SUB_KEY;

export const get = (path: string, payload?: any, viewAs?: string, headers?: any, overrideAuth?: string, onDownloadProgress?: (progressEvent: any) => void) => {
    let params = '';
    if (Object.keys(payload ?? {}).length > 0) {
        params = '?';
        Object.keys(payload).forEach((key) => {
            params += `${key}=${payload[key]}&`;
        });
        params = params.substring(0, params.length - 1);
    }
    return axios.get(`${endpoint}${path}${params}`, {
        headers: {
            ...viewAs && { 'X-View-As': viewAs },
            ...headers && { ...headers },
            Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
            'OCP-APIM-Subscription-Key': ocpKey,
        },
        onDownloadProgress,
    });
};

export const post = (path: string, payload: any, viewAs?: string, headers?: any, overrideAuth?: string) => axios.post(`${endpoint}${path}`, payload, {
    headers: {
        ...viewAs && { 'X-View-As': viewAs },
        ...headers && { ...headers },
        Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
});

export const postMulti = (path: string, data: FormData, headers?: any, overrideAuth?: string) => fetch(
    `${endpoint}${path}`,
    {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
            'Ocp-Apim-Subscription-Key': import.meta.env.VITE_OCP_APIM_SUB_KEY ?? '',
            ...headers,
        },
        body: data,
    },
);

export const patch = (path: string, payload: any, viewAs?: string, headers?: any, overrideAuth?: string) => axios.patch(`${endpoint}${path}`, payload, {
    headers: {
        ...viewAs && { 'X-View-As': viewAs },
        ...headers && { ...headers },
        Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
});

export const put = (path: string, payload: any, viewAs?: string, headers?: any, overrideAuth?: string) => axios.put(`${endpoint}${path}`, payload, {
    headers: {
        ...viewAs && { 'X-View-As': viewAs },
        ...headers && { ...headers },
        Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
});

export const del = (path: string, _: any, viewAs?: string, headers?: any) => axios.delete(`${endpoint}${path}`, {
    headers: {
        ...viewAs && { 'X-View-As': viewAs },
        ...headers && { ...headers },
        Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
});

export const getBlob = (path: string, onDownloadProgress?: (progressEvent: any) => void) => axios.get(`${endpoint}${path}`, {
    headers: {
        Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
    responseType: 'blob',
    onDownloadProgress,
});

export const getReturnOps = (path: string, payload?: any, viewAs?: string, headers?: any, overrideAuth?: string) => {
    let params = '';
    if (Object.keys(payload ?? {}).length > 0) {
        params = '?';
        Object.keys(payload).forEach((key) => {
            params += `${key}=${payload[key]}&`;
        });
        params = params.substring(0, params.length - 1);
    }
    return axios.get(`${returnOpsEndpoint}${path}${params}`, {
        headers: {
            ...viewAs && { 'X-View-As': viewAs },
            ...headers && { ...headers },
            Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
            'OCP-APIM-Subscription-Key': ocpKey,
        },
    });
};

export const postReturnOps = (path: string, payload: any, viewAs?: string, headers?: any, overrideAuth?: string) => axios.post(`${returnOpsEndpoint}${path}`, payload, {
    headers: {
        ...viewAs && { 'X-View-As': viewAs },
        ...headers && { ...headers },
        Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
        'OCP-APIM-Subscription-Key': ocpKey,
    },
});

export const postReturnOpsMulti = (path: string, data: FormData, _viewAs?: string, headers?: any, overrideAuth?: string) => fetch(
    `${returnOpsEndpoint}${path}`,
    {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${overrideAuth || sessionStorage.getItem('ACCESS_TOKEN')}`,
            'Ocp-Apim-Subscription-Key': import.meta.env.VITE_OCP_APIM_SUB_KEY ?? '',
            ...headers,
        },
        body: data,
    },
);

const request = (dispatch: any, type: string, payload: any) => {
     
    if (payload.onSuccess) delete payload.onSuccess;

    dispatch({
        type,
        payload,
    });
};

export default request;
